import { useEffect } from 'react';
import { loadVariantCssVarMap } from '../components/cmv2/utils/globalStyles';
import { useFetchBulkVariants } from 'ContentData/queries/VariantQuery';
export const useLoadBulkVariantStyles = () => {
  const {
    data: bulkVariantsMap
  } = useFetchBulkVariants();
  useEffect(() => {
    if (!bulkVariantsMap) return;
    Object.keys(bulkVariantsMap).forEach(variantDefinitionName => {
      const {
        variantDefinition,
        overrides
      } = bulkVariantsMap[variantDefinitionName] || {};
      if (variantDefinition) {
        loadVariantCssVarMap(variantDefinition, overrides);
      }
    });
  }, [bulkVariantsMap]);
};